import type { IndividualsGeoJsonResponse } from "@services/individuals/getGeoJson/type";
import {
  GENDER_OPTIONS,
  MARKING_TYPE_OPTIONS,
  SITUATION_OPTIONS,
  type Gender,
  type MarkingType,
  type Situation,
} from "@typings/entities/individuals";

export function getSituationLabel(situation: Situation): string {
  const found = SITUATION_OPTIONS.find((opt) => opt.value === situation);
  return found ? found.label : situation;
}

export function getGenderLabel(gender: Gender): string {
  const found = GENDER_OPTIONS.find((opt) => opt.value === gender);
  return found ? found.label : gender;
}

export function getMarkingTypeLabel(markingType: MarkingType): string {
  const found = MARKING_TYPE_OPTIONS.find((opt) => opt.value === markingType);
  return found ? found.label : markingType;
}

export function mapColorToIndividuals(
  geoJson: IndividualsGeoJsonResponse,
): IndividualsGeoJsonResponse {
  return {
    ...geoJson,
    features: geoJson.features.map((feature) => ({
      ...feature,
      properties: {
        ...feature.properties,
        color: feature.properties.hasGPS ? "#2B7FFF" : "#808080",
      },
    })),
  };
}
